export default __webpack_public_path__ + "static/media/nova38.ddf47098.png";